import React from 'react';
import { TrendingUp, TrendingDown, AlertTriangle, Target } from 'lucide-react';

// Get score color and label based on value
const getScoreInfo = (score) => {
  if (score === null || score === undefined) {
    return { color: 'bg-gray-500', textColor: 'text-gray-400', label: 'Non disponible', icon: null };
  }
  if (score >= 75) {
    return { color: 'bg-[#00ff88]', textColor: 'text-[#00ff88]', label: 'Opportunité forte', icon: TrendingUp };
  }
  if (score >= 50) {
    return { color: 'bg-[#ffa502]', textColor: 'text-[#ffa502]', label: 'À surveiller', icon: Target };
  }
  if (score >= 25) {
    return { color: 'bg-[#ff8c00]', textColor: 'text-[#ff8c00]', label: 'Prudence', icon: AlertTriangle };
  }
  return { color: 'bg-[#ff4757]', textColor: 'text-[#ff4757]', label: 'Risque élevé', icon: TrendingDown };
};

// Compact badge for screener cards - just the score in a circle
export const ValoramapScoreBadge = ({ score, size = 'sm' }) => {
  if (score === null || score === undefined) {
    return <span className="text-gray-600 text-sm">-</span>;
  }

  const { color } = getScoreInfo(score);
  const sizeClasses = size === 'lg' 
    ? 'w-10 h-10 text-base font-bold' 
    : 'w-7 h-7 text-xs font-semibold';

  return (
    <div 
      className={`${color} ${sizeClasses} rounded-full flex items-center justify-center text-[#0f0f23]`}
      title={`VALORAMAP Score: ${score}/100`}
    >
      {score}
    </div>
  );
};

// Full badge with label for stock detail header
export const ValoramapScoreHeader = ({ score }) => {
  if (score === null || score === undefined) return null;

  const { color, textColor, label, icon: Icon } = getScoreInfo(score);

  return (
    <div className="flex items-center gap-2">
      <div 
        className={`${color} w-10 h-10 rounded-full flex items-center justify-center text-[#0f0f23] font-bold text-lg`}
        title={`VALORAMAP Score: ${score}/100`}
      >
        {score}
      </div>
      <div className="flex flex-col">
        <span className="text-xs text-gray-500">VALORAMAP Score</span>
        <span className={`text-sm font-medium ${textColor} flex items-center gap-1`}>
          {Icon && <Icon className="w-3 h-3" />}
          {label}
        </span>
      </div>
    </div>
  );
};

// Card version for displaying in a metrics grid
export const ValoramapScoreCard = ({ score }) => {
  const { color, textColor, label, icon: Icon } = getScoreInfo(score);

  return (
    <div className="bg-white/5 border border-white/10 rounded-lg p-4">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm text-gray-400">VALORAMAP Score</span>
        {Icon && <Icon className={`w-4 h-4 ${textColor}`} />}
      </div>
      <div className="flex items-center gap-3">
        {score !== null && score !== undefined ? (
          <>
            <div 
              className={`${color} w-12 h-12 rounded-full flex items-center justify-center text-[#0f0f23] font-bold text-xl`}
            >
              {score}
            </div>
            <div>
              <p className={`font-medium ${textColor}`}>{label}</p>
              <p className="text-xs text-gray-500">sur 100</p>
            </div>
          </>
        ) : (
          <p className="text-gray-500">Non disponible</p>
        )}
      </div>
    </div>
  );
};

export default ValoramapScoreBadge;
